export function AddChannel() {
  return (
    <v-btn>
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  );
}

export function Create() {
  return (
    <v-btn
      prepend-icon="mdi-plus"
      color="primary">
      Create
    </v-btn>
  );
}

export function Broadcast() {
  return <v-icon>mdi-access-point</v-icon>;
}

import SectionHelp from '../templates/SectionHelp.mdx';
import ExampleHelpButton from '../example-buttons/ExampleHelpButton.vue';
import Tag from '../../Shared/Tag.vue';

import assignedChannels from '../images/assigned-channel.png';

<SectionHelp />

# Channel Information

This page is where you can Create, Remove, Edit or Delete Channels.

## What is a Channel?

A Channel is a collection of Queues (playlists) and Scenes.

## Create a Channel

{/* Editor note */}
{/* Bug or feature? */}
**Note:** Once a channel is created you cannot rename it.

Click the <AddChannel /> button (top left), the **Create Channel** menu will open, type in the name of your channel then click <Create />

If you click on your newly created Channel, the Queue Deck will open. For more help click the <ExampleHelpButton /> button in the Queue Deck.

## How do I know which Channels are live?

Any Channel that is assigned to a Frame will be live. You can see Which Channels are assigned to Frames by the special Frame tag.

<figure>
  <img
    src={assignedChannels}
    alt="A Channel Assigned to Frame 1"
  />
  <figcaption>A Channel Assigned to Frame 1</figcaption>
</figure>

## Search

If you start typing here, only the items that match your search terms will be shown.
